import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const Play: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.525 18.0252C9.19167 18.2418 8.85417 18.2543 8.5125 18.0627C8.17083 17.871 8 17.5752 8 17.1752V6.82518C8 6.42518 8.17083 6.12935 8.5125 5.93768C8.85417 5.74602 9.19167 5.75852 9.525 5.97518L17.675 11.1502C17.975 11.3502 18.125 11.6335 18.125 12.0002C18.125 12.3669 17.975 12.6502 17.675 12.8502L9.525 18.0252Z' fill='currentColor' />
  </svg>
)

export default Play;
